import './ViewMessageForm.scss'
import TextArea from "devextreme-react/text-area";
import { Field } from "../../../../layouts";
import { Box, Item } from 'devextreme-react/box';
import { TextBox } from "devextreme-react/text-box";
import { formatShortDateShortTime } from "../../../../utils/date-utils";
import { MessageType } from '../types/MessageType';
import { MessageDetails } from '../types/MessageDetails';
import IncomingMessageIcon from '../../../../assets/images/IncomingMessage.svg';
import OutgoingMessageIcon from '../../../../assets/images/OutgoingMessage.svg';
import FileAttachmentLink from '../../file-attachment-link/components/FileAttachmentLink';

export default function ViewMessageForm(props: { message: MessageDetails }) {

	return (
		<div className='view-message-form'>
			<Box>
				<Item baseSize={65}>
					<img src={props.message.inboundFlag ? IncomingMessageIcon : OutgoingMessageIcon}
						className='message-icon'></img>
				</Item>
				<Item ratio={1}>
					<Field label="From" vertical={true}>
						<TextBox readOnly={true} value={props.message.from}></TextBox>
					</Field>
				</Item>
				<Item ratio={1}>
					<Field label="To" vertical={true}>
						<TextBox readOnly={true} value={props.message.to}></TextBox>
					</Field>
				</Item>
			</Box>

			<Box>
				<Item ratio={1}>
					<Field label="Message Type" vertical={true}>
						<TextBox readOnly={true} value={props.message.messageType}></TextBox>
					</Field>
				</Item>
				<Item ratio={1}>
					<Field label="Created On" vertical={true}>
						<TextBox readOnly={true} value={formatShortDateShortTime(props.message.createdOn)}></TextBox>
					</Field>
				</Item>
				<Item ratio={1}>
					<Field label="Status" vertical={true}>
						<TextBox readOnly={true} value={props.message.status}></TextBox>
					</Field>
				</Item>
			</Box>

			<Field label='Subject' visible={props.message.messageTypeID === MessageType.Email} vertical={true}>
				<TextBox readOnly={true} value={props.message.subject}></TextBox>
			</Field>

			<Field label='Message' vertical={true}>
				<TextArea readOnly={true} value={props.message.body} height={160} className="view-message-body"></TextArea>
			</Field>
			{
				props.message.attachments && props.message.attachments.length > 0 &&
				<Field label='Attachments' className='message-attachments'>
					{
						props.message.attachments.map(attachment => {
							return <FileAttachmentLink
								key={attachment.awsS3Key}
								caption={attachment.fileName}
								awsS3Key={attachment.awsS3Key}
								fileName={attachment.fileName}
							/>
						})
					}
				</Field>
			}
		</div>
	)
}
